/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportProductsGroupsType
 */
export interface ReportProductsGroupsType {
    /**
     * 
     * @type {object}
     * @memberof ReportProductsGroupsType
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportProductsGroupsType
     */
    sum: object;
}

export function ReportProductsGroupsTypeFromJSON(json: any): ReportProductsGroupsType {
    return ReportProductsGroupsTypeFromJSONTyped(json, false);
}

export function ReportProductsGroupsTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportProductsGroupsType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportProductsGroupsTypeToJSON(value?: ReportProductsGroupsType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


